import axios, { AxiosError } from 'axios';
import logger from '../logger';

type ActionDetails = {
  site: string;
  reason: string;
};

export async function redirectUser(payload: ActionDetails) {
  try {
    const response = await axios.post('/auth/generate_tms_token', payload);

    return `${payload.site}?${response.data}`;
  } catch (err) {
    logger.error(err);
    if (
      (err as AxiosError).response &&
      (err as AxiosError).response?.status === 403
    ) {
      throw new Error('You are not authorised to login to this site.');
    }

    throw new Error(
      'Looks like we hit a snag. Please refresh the page and try again.'
    );
  }
}
